class HeaderScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    var windowWidth = $(window).width();
    var windowSm = 768;
    if (windowWidth <= windowSm) {
      //横幅768px以下（スマホ）に適用させるJavaScriptを記述
    } else {
      $(function () {
        const headNav = $('.js-header');
        $(window).scroll(function () {
          if($(this).scrollTop() > 100 && headNav.hasClass('is-small') == false) {
            headNav.addClass('is-small');
          } 
          if($(this).scrollTop() > 800 && headNav.hasClass('is-fixed') == false) {
            headNav.addClass('is-fixed');
          }
        });
      });
    }
  }
}
